'use client'
import React from 'react'
import Card from '../../card'
import CustomLink from '../../customLink'
import { getSlugUrl } from '@/shared/utils'

function ProbableEleven({ data }: any) {
  if (data?.oOverview?.oTeam1?.aPlayers?.length > 0 && data?.oOverview?.oTeam2?.aPlayers?.length > 0) {
    return (
      <>
        <h4 className='text-sm md:text-lg font-medium md:font-bold mt-4 mb-4 md:mb-6 md:mt-8 text-textOffWhite'>Probable Playing XI</h4>
        <Card className='flex flex-col border-tabBorder !bg-cardBg'>
          <div className='font-bold text-textOffWhite'>{data?.oOverview?.oTeam1?.oTeam?.sTitle}</div>
          <div className='grid grid-cols-12 w-full mt-2'>
            <div className='text-textDselected col-span-12 md:col-span-2'>Probable XI</div>
            <span className='w-full col-span-12 md:col-span-10'>
              {data?.oOverview?.oTeam1?.aPlayers
                ?.map((p: any) => (
                  <CustomLink key={p?._id} href={getSlugUrl('/' + p?.oSeo?.sSlug)}>
                    <span className='text-xs md:text-base'>{p?.sShortName}</span>
                  </CustomLink>
                ))
                .reduce((prev: any, curr: any) => (prev === '' ? [curr] : [prev, ', ', curr]), '')}
            </span>
          </div>
          <div className='grid grid-cols-12 w-full mt-4'>
            <div className='text-textDselected col-span-12 md:col-span-2'>Bench</div>
            <span className='w-full col-span-12 md:col-span-10 text-t-secondary'>
              {data?.oOverview?.oTeam1?.aBenchedPlayers
                ?.map((p: any) => (
                  <CustomLink key={p?._id} href={getSlugUrl('/' + p?.oSeo?.sSlug)}>
                    <span className='text-t-secondary hover:text-primary-500 text-xs md:text-base'>{p?.sShortName}</span>
                  </CustomLink>
                ))
                .reduce((prev: any, curr: any) => (prev === '' ? [curr] : [prev, ', ', curr]), '')}
            </span>
          </div>
        </Card>
        <Card className='flex flex-col mt-4 border-tabBorder !bg-cardBg'>
          <div className='font-bold text-textOffWhite'>{data?.oOverview?.oTeam2?.oTeam?.sTitle}</div>
          <div className='grid grid-cols-12 w-full mt-2'>
            <div className='text-textDselected col-span-12 md:col-span-2'>Probable XI</div>
            <span className='w-full col-span-12 md:col-span-10 text-textOffWhite'>
              {data?.oOverview?.oTeam2?.aPlayers
                ?.map((p: any) => (
                  <CustomLink key={p?._id} href={getSlugUrl('/' + p?.oSeo?.sSlug)}>
                    <span className='text-textOffWhite text-xs md:text-base'>{p?.sShortName}</span>
                  </CustomLink>
                ))
                .reduce((prev: any, curr: any) => (prev === '' ? [curr] : [prev, ', ', curr]), '')}
            </span>
          </div>
          <div className='grid grid-cols-12 w-full mt-4'>
            <div className='text-textDselected col-span-12 md:col-span-2'>Bench</div>
            <span className='w-full col-span-12 md:col-span-10 text-t-secondary'>
              {data?.oOverview?.oTeam2?.aBenchedPlayers
                ?.map((p: any) => (
                  <CustomLink key={p?._id} href={getSlugUrl('/' + p?.oSeo?.sSlug)}>
                    <span className='text-textDselected hover:text-primary-500 text-xs md:text-base'>{p?.sShortName}</span>
                  </CustomLink>
                ))
                .reduce((prev: any, curr: any) => (prev === '' ? [curr] : [prev, ', ', curr]), '')}
            </span>
          </div>
        </Card>
      </>
    )
  }
}

export default ProbableEleven
